import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const BanknoteCoinsStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M18.668 30.668C20.876 30.668 22.668 32.46 22.668 34.668C22.668 36.8746 20.876 38.667 18.668 38.667C16.46 38.667 14.668 36.8746 14.668 34.668C14.668 32.46 16.46 30.668 18.668 30.668ZM18.668 32.9346C17.712 32.9346 16.9346 33.712 16.9346 34.668C16.9346 35.6226 17.712 36.4004 18.668 36.4004C19.624 36.4004 20.4014 35.6226 20.4014 34.668C20.4014 33.712 19.624 32.9346 18.668 32.9346ZM28.001 24.001C30.2089 24.001 32.0008 25.7931 32.001 28.001C32.001 30.2076 30.209 32 28.001 32C25.7931 31.9998 24.001 30.2075 24.001 28.001C24.0012 25.7932 25.7932 24.0012 28.001 24.001ZM28.001 26.2676C27.0452 26.2678 26.2678 27.0452 26.2676 28.001C26.2676 28.9555 27.0451 29.7332 28.001 29.7334C28.957 29.7334 29.7344 28.9556 29.7344 28.001C29.7342 27.0451 28.9569 26.2676 28.001 26.2676ZM37.335 14.6709L37.333 28.001H34.2676C34.2675 27.1998 34.1028 26.4383 33.8281 25.7344H35.0664L35.0684 16.9375L18.668 16.9355V25.7344H22.1748C21.9002 26.4383 21.7344 27.1984 21.7344 28.001H10.668V14.668L37.335 14.6709ZM12.9346 16.9346V25.7344H16.4014V16.9346H12.9346Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
